import { Pagination } from '@/domain/entities/Pagination'
import { Notification, NotificationData } from '@/domain/entities/Notification'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class NotificationDataMapper extends BaseResponseMapper {
  public convertNotificationFromApi(result: AxiosResponse<any>): Notification {
    const { data } = result
    return new Notification(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new NotificationData(
            val.id,
            val.owner_id,
            val.owner_type,
            val.title,
            val.content,
            val.is_deletable,
            val.created_at,
            val.updated_at,
            val.attachment
          )
      )
    )
  }
}
